import { Routes } from "@angular/router";

import { membershipDashboardRoutes } from "../friends-of-oman-privilages";
import { learningCenterDashboardRoutes } from "../learning-center";

import { convertTokenJWT, UserRole } from "src/app/core";

export const dashboardRoutes: Routes = [
  {
    path: "",
    title: "DASHBOARD.TITLE",
    canMatch: [
      () => {
        const roleCode = convertTokenJWT()?.RoleCode;
        return roleCode === UserRole.LEARNINGCENTER;
      },
    ],
    children: learningCenterDashboardRoutes,
  },
  {
    path: "",
    title: "DASHBOARD.TITLE",
    canMatch: [
      () => {
        const roleCode = convertTokenJWT()?.RoleCode;
        return roleCode === UserRole.MUSEUMFRIENDSDEPARTMENT;
      },
    ],
    children: membershipDashboardRoutes,
  },
  {
    path: "",
    redirectTo: "booking",
    pathMatch: "full",
    canMatch: [
      () => {
        const roleCode = convertTokenJWT()?.RoleCode;
        return ![UserRole.LEARNINGCENTER, UserRole.MUSEUMFRIENDSDEPARTMENT].includes(roleCode!);
      },
    ],
  },
  {
    path: "",
    title: "DASHBOARD.TITLE",
    canMatch: [
      () => {
        const roleCode = convertTokenJWT()?.RoleCode;
        return ![UserRole.LEARNINGCENTER, UserRole.MUSEUMFRIENDSDEPARTMENT].includes(roleCode!);
      },
    ],
    data: {
      tabs: [
        {
          key: "booking",
          title: "DASHBOARD.BOOKING",
          routerLink: "booking",
        },
        {
          key: "approvedRequestes",
          title: "DASHBOARD.VISIT",
          routerLink: "approved-requests",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      {
        path: "booking",
        title: "DASHBOARD.BOOKING",
        loadComponent: () => import("./pages/booking/booking.component").then((c) => c.BookingComponent),
      },
      {
        path: "approved-requests",
        title: "DASHBOARD.VISIT",
        loadComponent: () => import("./pages/approved-requests/approved-requests.component").then((c) => c.ApprovedRequestsComponent),
      },
    ],
  },
];
